import Vue from 'vue'
import vuex from 'vuex'
import userinfo from '../vuex/userinfo'
import lgInfo from '../views/lgSystem/lg_store/lgInfo'
import findDropDownListModule from '../vuex/findDropDownListModule'

var qs = require("querystring")
Vue.prototype.qs=qs;
Vue.use(vuex)
const state={
  author:'LanJC',
  count:1,
  totalcount:'',
  tabledata:'',
  is_manager: '',
  notificationList: '',
  formLabelWidth: '130px',
  selectWidth: '188px',
  stepActiveIndex: '',
  user_id: localStorage.getItem("user_id"),
  collapse: '',
  tableHeight: null,
  width: '',
  theme: localStorage.getItem('theme'),
  showSensitiveData: true,// 控制是否显示敏感数据
  isExporting: false,
}
const mutations= {
  toggleSensitiveData(state) {
    state.showSensitiveData = !state.showSensitiveData;
  },
  showSensitiveData(state) {
    state.showSensitiveData = true;
  },
  setExporting(state, value) {
    state.isExporting = value;
  },
  getnotificationList(state, value) {
    state.notificationList = value;
  },
  change_is_manager(state, value) {
    state.is_manager = value;
  },
  change_user_id(state, value) {

  },
  getCollapse(state, value) {
    state.collapse = value;
  },
  setTheme(state,value){
    state.theme = value;
  },
  getWidth(state) {
    state.width = document.getElementById("table").scrollWidth;
  },
  handlestepActiveIndex(state,val){
    state.stepActiveIndex=val;
  },
  computedTableHeight(state) {
    let tableHeight = document.getElementById("table").scrollHeight;//表格流体高度


    //页面可视高度-表格距离顶部距离
    let computeHeight = document.body.clientHeight - document.getElementById("table").offsetTop - 80;
    if (tableHeight < computeHeight){
      state.tableHeight = null;
    }else {
      state.tableHeight = computeHeight;
    }
  }
}
const actions= {
}

export default new vuex.Store({
  state,mutations,actions,
  modules: {
    userinfo: userinfo,
    findDropDownListModule: findDropDownListModule,
    lgInfo: lgInfo,
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js